import React from "react";
import { useQuery } from "@tanstack/react-query";
import { axiosget } from "../../helpers/httprequest";
import PageTitle from "../../components/PageTitle";
import Loader from "../../components/Loader";
import ErrorResponse from "../../components/ErrorResponse";
import ActionPayment from "./ActionPayment";
import "./Payment.css"; // We'll create this CSS file

const Payment = () => {
  const { 
    data, 
    isLoading, 
    error 
  } = useQuery({
    queryKey: ["myTuitionHistory"],
    queryFn: async () => {
      const response = await axiosget(`ms_transactions`);
      return response?.data;
    },
  });

  const renderPaymentCards = () => {
    if (!data || data?.type !== undefined) return null;

    return (
      <div className="payment-grid">
        {data?.map((payment, index) => (
          <div 
            className={`payment-card ${payment?.isActive ? "active" : "inactive"}`}
            key={`payment-card-${index}`}
            style={{ '--delay': index * 0.1 + 's' }}
          >
            <div className="card-glow"></div>
            <div className="card-content">
              <div className="card-header">
                <h3 className="programme-code">{payment?.programme?.code}</h3>
                <div className={`status-badge ${payment?.isActive ? "active" : "inactive"}`}>
                  {payment?.isActive ? "ACTIVE" : "INACTIVE"}
                </div>
              </div>
              
              <h4 className="programme-name">{payment?.programme?.name}</h4>
              
              <div className="card-details">
                <div className="detail-row">
                  <span className="detail-label">Level:</span>
                  <span className="detail-value">
                    {payment?.level}
                  </span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Semester:</span>
                  <span className="detail-value">
                    {payment?.semester}
                  </span>
                </div>
                
                <div className="detail-row">
                  <span className="detail-label">Admission:</span>
                  <span className={`detail-value ${payment?.isAdmitted ? "success" : "danger"}`}>
                    {payment?.isAdmitted ? "✓ Admitted" : "✗ Not Admitted"}
                  </span>
                </div>
              </div>
              <div className="card-footer">
                <ActionPayment v={payment} />
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className="payment-container">
      <PageTitle 
        title="TUITION PORTAL" 
        sub="Your Payment History & Academic Status" 
      />
      
      {isLoading && (
        <div className="loading-overlay">
          <Loader />
          <div className="loading-text">Fetching your records...</div>
        </div>
      )}
      
      {error && (
        <ErrorResponse 
          type="danger" 
          message={`Connection error: ${error.message}`} 
        />
      )}
      
      {data?.type !== undefined && (
        <ErrorResponse 
          type="danger" 
          message={data?.message || "Server processing error"} 
        />
      )}
      
      {data?.type === undefined && data?.wallet <= 0 && (
        <ErrorResponse 
          type="warning" 
          title="FUNDS REQUIRED"
          message="Your education wallet needs attention. Please deposit funds to continue." 
          icon="💰"
        />
      )}
      
      {renderPaymentCards()}
    </div>
  );
};

export default Payment;